export default __webpack_public_path__ + "images/KE.a614d80.png";